<div class="mb-6" *ngIf="auctionId">
    <app-header [id]="auctionId" [shareSocialMediaData]="{type: 'item', id:idItemDetails}" [showSocialShare]="false"></app-header>
</div>

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />


<ng-container *ngIf="isLoading ; else content">


    <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading item" />
    </div>
</ng-container>

<ng-template #content>

    <div class="container mx-auto mt-6 px-4 lg:px-20 min-h-auto">



        <div class="flex flex-col justify-between lg:flex-row justify-end mb-3 ">

            <div class="card flex justify-start">
                <p-breadcrumb [model]="itemsBreadcrumb" [home]="home"
                    class="text-[14px] font-mulish text-gray-700"></p-breadcrumb>
            </div>


            <auctions-items-search-bar [auctionId]="auctionId ? auctionId : 0" [shouldGoToSearch]="true" />



        </div>
        <div class="w-full  flex justify-end">
            <div class="flex items-center gap-2">
                <a (click)="openPopupCenter(facebookShareUrl(), 'popUpWindow', 550, 550)">
                    <fa-icon [icon]="faFacebook"
                        style="color: #0866ff; cursor: pointer; font-size: 24px; margin-right: 10px;"
                        aria-label="Share to Facebook Logo"></fa-icon>
                </a>
                <a [href]="twitterShareUrl()" target="_blank">
                    <fa-icon [icon]="faXTwitter" style="color: black; font-size: 24px; margin-right: 10px;"
                        aria-label="Share to Twitter Logo"></fa-icon>
                </a>
                <a [href]="linkedinShareUrl()" target="_blank">
                    <fa-icon [icon]="faLinkedin" style="color: #0077B5; font-size: 26px; margin-right: 10px; "
                        aria-label="Share to LinkedIn Logo"></fa-icon>
                </a>
                <div  [cdkCopyToClipboard]="copyUrl()" (cdkCopyToClipboardCopied)="onCopyUrl()" class="clickable-div h-26px w-26px">
                    <fa-icon [icon]="faLink" style="color: rgba(74, 74, 74, 1); font-size: 22px !important; "
                        aria-label="Copy URL"></fa-icon>
                </div>
            </div>
        </div>
        <div class="flex flex-col md:flex-row gap-8 items-stretch pt-6">

            <div class="md:w-1/2 flex flex-col items-center max-w-[350px] mx-auto md:mx-0">
                <app-gallery-full-image [gallery]="gallery" [itemModal]="itemModal">
                </app-gallery-full-image>
            </div>

            <div class="md:w-1/2 flex flex-col justify-between">
                <div>
                    <h1 class="text-[var(--p-info-500)]  font-medium text-lg cursor-pointer hover:underline"
                        [routerLink]="['/auction', itemModal?.auctionId]">{{
                        itemModal?.organizationName }}
                    </h1>

                    <p class="text-[12px] text-gray-400 font-medium">{{ itemModal?.category }}</p>
                    <div class="flex items-center">
                        <h3 class="text-[24px] font-semibold text-[var(--p-info-500)]" [innerHTML]="safeItemNameHtml()">
                        </h3>
                        <fa-icon [icon]="isFavorited ? faBookmarkSolid : faBookmarkRegular"
                            class="ml-2 text-[var(--p-info-500)] text-lg cursor-pointer" (click)="toggleFavorite()"></fa-icon>
                    </div>
                    <div class="text-gray-700 mt-2 flex items-center m-0">
                        <span class="text-[20px] font-semibold text-custom-black ">{{ itemModal?.isBuyable &&
                            !itemModal?.currentLeadingBid ? itemModal?.buyNowPrice : itemModal?.currentLeadingBid }}
                        </span>

                        <span class="text-primary-500 text-[15px] md:text-[18px] font-medium ml-2 ">
                            {{
                            itemModal?.isBiddable
                            ? (itemModal?.numberOfBids === 0 ? 'Opening Bid' : 'Leading Bid')
                            : (itemModal?.isBuyable ? 'Buy Now' : 'Leading Bid')
                            }}
                        </span>

                        <ng-container *ngIf="itemModal?.hasReserve">
                            <div class="flex justify-center items-center  cursor-pointer ml-6"
                                (click)="openReserveModal()">
                                <ng-container *ngIf="itemModal?.isAboveReserve; else notMet">
                                    <fa-icon [icon]="faSquareCheck "
                                        class="text-sm text-lime-600   font-bold"></fa-icon>
                                    <h2 class=" text-[15px] md:text-[18px] font-medium ml-1">Reserve Met</h2>
                                </ng-container>

                                <ng-template #notMet>
                                    <fa-icon [icon]="faLock " class="text-orange-600 text-base font-bold"></fa-icon>
                                    <h2 class=" text-[15px] md:text-[18px] font-medium  ml-1 ">Reserve Not Met</h2>
                                </ng-template>
                            </div>
                        </ng-container>


                    </div>


                    <div class=" flex items-center mt-4">
                        @if(itemModal?.myMaxBid != null && itemModal?.isLeader)
                        {
                        <div class="">
                            {{itemModal?.myMaxBid}} <span class="text-primary-500 text-[15px] font-medium ml-1">My
                                Maximun
                                Bid</span>
                        </div>
                        }

                        <!-- @if(itemModal && itemModal.isLeader)
                        {
                        <div class="flex items-center ml-2 ">
                            <fa-icon [icon]="faCrown" class="mr-1 text-lg  text-[var(--fs-forest)]"></fa-icon>
                            You're Leading
                        </div>
                        } -->

                    </div>
                    <p>
                        <span *ngIf="itemModal?.estimatedValue; else noEstimatedValue" class="text-[#6E6E6E] text-sm">
                            {{ isAmountEstimatedValue(itemModal!.estimatedValue) ? itemModal?.estimatedValue + '
                            Estimated Value' :
                            'Priceless' }}
                        </span>
                        <ng-template #noEstimatedValue>
                            <span class="text-gray-500 text-xs invisible">-</span>
                        </ng-template>
                    </p>


                </div>

                <!-- template bid controls -->

                <ng-template #bidControls>
                    <div class="mt-2">
                        @if (isAuthenticated().isAuthenticated) {
                        <div class="flex flex-col md:flex-row gap-4   w-full">

                            <div class="flex-1">
                                <label
                                    class="block text-gray-500 text-sm font-semibold tracking-wide">{{myBidLabel}}</label>
                                <input pInputText [(ngModel)]="selectedBid" [placeholder]="bidPlaceholder"
                                    class="w-full pl-3 text-sm h-[40px] placeholder:text-[12px] placeholder:text-gray-100 border border-gray-300 rounded-md"
                                    (input)="showLowBidError = false; showMaxBidError = false;" pattern="[0-9]+"
                                    #bidInput="ngModel">
                                @if (bidInput.invalid && (bidInput.dirty || bidInput.touched)) {
                                <p-message severity="error" size="small">
                                    Please enter a whole amount, without symbols or letters.
                                </p-message>
                                }

                            </div>

                            <!-- [placeholder]="itemModal?.numberOfBids! > 0 
                        ? itemModal?.minimumBid + ' Next Minimum Bid' 
                        : itemModal?.minimumBid + ' Opening Bid'" -->
                            <div class="flex-1">
                                <label class="block text-gray-500 text-sm font-semibold tracking-wide">Credit
                                    Card</label>
                                <p-select [options]="cardOptions()" [(ngModel)]="selectedCardId" placeholder=""
                                    optionLabel="label" optionValue="value" class="w-full h-[40px]"
                                    [style]="{ 'fontSize': '12px' ,color: 'var(--p-info-500)'  }"></p-select>
                                <button class="flex items-center space-x-2 text-[var(--p-info-500)] font-semibold"
                                    (click)="onAddCreditCard()">
                                    <i class=" pi pi-credit-card"></i>
                                    <span class="text-xs">Add New Credit Card</span>
                                </button>
                            </div>

                        </div>

                        <div class="flex flex-col md:flex-row md:justify-between md:items-center  mt-4">

                            <div class="flex items-center">
                                <p-radioButton name="bidProxy" value="PROXY" [(ngModel)]="selectedBidOption"
                                    class="mr-1 scale-75 mt-1"></p-radioButton>
                                <span class="text-sm font-mulish">Bid up this amount</span>
                            </div>


                            <div class="flex items-center">
                                <p-radioButton name="bidStraight" value="STRAIGHT" [(ngModel)]="selectedBidOption"
                                    class="mr-1 scale-75 mt-1"></p-radioButton>
                                <span class="text-sm font-mulish">Bid exactly this amount</span>


                                <span class="pi pi-question-circle text-blue-500 cursor-pointer ml-2 block md:hidden"
                                    title="More info" (click)="onQuestionMark()"></span>
                            </div>


                            <div class="hidden md:flex items-center">
                                <span class="pi pi-question-circle text-blue-500 cursor-pointer" title="More info"
                                    (click)="onQuestionMark()"></span>
                            </div>
                        </div>

                        <button pButton
                            class="p-button mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                            [rounded]="true" (click)="validateBid()">
                            <i class="pi !text-[var(--p-text-color-primary)] absolute left-3"
                                [ngClass]="itemModal?.isBiddable || itemModal?.isBuyable ? 'pi-credit-card' : 'pi-bookmark'">
                            </i>
                            <span class="font-mulish !text-[var(--p-text-color-primary)] text-center w-full">
                                Place a Bid
                            </span>
                        </button>

                        @if(itemModal!.biddingType === 'ONLINE_AND_LIVE'){
                            <ng-container *ngTemplateOutlet="OnlineToLiveEvent"></ng-container>
                        }

                        @if (creditCardErrorMessage !== '') {
                            <div class="text-red-500 text-sm mt-1">
                                {{creditCardErrorMessage}}
                            </div>
                        }
                        <div *ngIf="showLowBidError" class="text-red-500 text-sm mt-1">
                            Your bid of {{selectedBid | currency:'USD':'symbol':'1.2-2'}} is lower than the minimum bid
                            required.
                        </div>

                        <div *ngIf="showMaxBidError" class="text-red-500 text-sm mt-1">
                            Your bid must be higher than your current maximum bid {{ itemModal?.myMaxBid }}.
                        </div>

                        <div class="flex flex-col md:flex-row justify-between md:items-center mt-4 ">
                            <div class="flex items-center text-gray-600 space-x-1 text-[12px]">
                                <i class="pi pi-users text-[var(--p-info-500)] font-bold text-xs"></i>
                                <span class="">
                                    {{ itemModal?.numberOfBids === 0 ? 'Be the first to bid!' :
                                    itemModal?.numberOfBids + ' bids have been placed.' }}
                                </span>

                            </div>
                            <div class="flex items-center text-gray-600 space-x-1 text-[12px] mt-1">
                                <i class="pi pi-calendar text-[var(--p-info-500)] font-bold text-xs"></i>
                                <span>{{ itemDateFormat()}}</span>
                            </div>
                        </div>
                        <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                            <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                        </p>
                        } @else {
                        @if (isShowingLoginIframe()) {
                        <div class="border border-solid border-[var(--p-primary-500)] rounded-xl">
                            <app-sign-in [loginPage]="loginPage" [loginUrl]="loginUrl()"></app-sign-in>
                        </div>
                        } @else {
                        <div>
                            <button pButton
                                class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                [rounded]="true" (click)="showLoginIframe()">
                                <i class="pi !text-[var(--p-text-color-secondary)] absolute left-3" [ngClass]="'pi-user'">
                                </i>
                                <span class="font-mulish !text-[var(--p-text-color-secondary)] text-center w-full">
                                    Sign In To Bid
                                </span>
                            </button>
                        </div>
                        }
                        }
                    </div>
                </ng-template>

                <!-- bid confirm template  -->

                <ng-template #bidConfirmTemplate>
                    <ng-container *ngIf="showConfirmTemplate">
                        <div class=" mt-4">
                            <div
                                class="bg-[rgba(25,166,223,0.2)] border border-[var(--fs-blue)] rounded-xl p-6 text-center">

                                <h3 class="text-xl font-mulish  font-bold mb-2 text-[var(--dark-blue)]">Confirm Bid</h3>
                                <p
                                    class="text-sm  text-center text-[var(--dark-blue)] text-left font-medium  font-mulish lg:ml-16">
                                    Please confirm your maximum bid of ${{selectedBid}} {{currency()}} using credit card
                                    {{ selectedCardName() }}.
                                </p>

                                @if(showCoverTheFee())
                                {
                                       <div class="flex items-center gap-2 mt-4">
                                    <input type="checkbox" id="chkCoverFee" class="  " [(ngModel)]="coverFeeConfirm" />
                                    <label for="coverFee"
                                        class="text-gray-500 text-[11px]  text-[var(--dark-blue)]  font-medium font-mulish ml-1 text-left">
                                        I'd like to cover the fee so 100% of my bid goes to the nonprofit
                                        (${{feeAmountSignal()}}
                                        {{currency()}}
                                        estimated).
                                        The final fee will be based on the total amount charged
                                        including any applicable taxes or shipping.
                                    </label>
                                </div>
                                }
                             
                            </div>
                            <div *ngIf="showLowBidError" class="text-red-500 text-sm mt-1">
                                {{errorMessage}}
                            </div>

                            <div class="mt-6 flex gap-2 ">

                                <button pButton type="button"
                                    class=" h-[40px] lg:h-[35px] !bg-white !border !border-[var(--p-primary-500)] !text-[var(--p-primary-500)] px-4 py-2 font-medium text-base flex-[1] !rounded-full flex justify-end items-center"
                                    (click)="onClickBack()">
                                    <i class="pi pi-angle-double-left text-xl"></i>
                                    <span class="font-semibold  text-center w-full text-base">
                                        Back
                                    </span>
                                </button>

                                <button pButton
                                    class=" h-[40px]  lg:h-[35px] !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full relative flex-[4] flex items-center justify-center gap-2"
                                    [rounded]="true" (click)="placeABid()">
                                    <i class="fa-solid fa-circle-check !text-[var(--p-text-color-secondary)] text-lg left-3">
                                    </i>
                                    <span class="font-semibold !text-[var(--p-text-color-secondary)] text-center w-full text-base">
                                        Confirm
                                    </span>
                                </button>
                            </div>
                            <div class="flex flex-col md:flex-row justify-between md:items-center mt-4 ">
                                <div class="flex items-center text-gray-600 space-x-1 text-[12px]">
                                    <i class="pi pi-users text-[var(--p-info-500)] font-bold text-xs"></i>
                                    <span class="">
                                        {{ itemModal?.numberOfBids === 0 ? 'Be the first to bid!' :
                                        itemModal?.numberOfBids + ' bids have been placed.' }}
                                    </span>

                                </div>
                                <div class="flex items-center text-gray-600 space-x-1 text-[12px] mt-1">
                                    <i class="pi pi-calendar text-[var(--p-info-500)] font-bold text-xs"></i>
                                    <span>{{itemDateFormat()}}</span>
                                </div>
                            </div>
                            <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                <ng-container *ngTemplateOutlet="FGFwording"></ng-container>
                            </p>
                        </div>
                    </ng-container>
                </ng-template>

                <!-- template status  bidding -->

                <ng-template #bidStatusTemplate>
                    <ng-container [ngSwitch]="bidResponseSignal()">
                        <ng-container *ngSwitchCase="'LEADER_PROXY_BID'">

                            <div class="bg-[#D4ECD5] rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#357B38]"> Congratulations!
                                </h3>
                                <p class="text-sm text-center text-sm mt-4 text-[#357B38]">
                                    Your <strong>Maximum of ${{ selectedBid}} {{currency()}} </strong> has been
                                    recorded.</p>
                                <p class="text-sm text-center text-sm text-[#357B38]">You are currently the
                                    <strong>Leader</strong> for item <strong>{{ itemModal?.name }}</strong> with a
                                    <strong>Leading Bid of {{ itemModal?.currentLeadingBid}} {{currency()}}.</strong>
                                </p>
                            </div>
                            <ng-template [ngTemplateOutlet]="templateBiddingButtons"></ng-template>
                        </ng-container>
                        <ng-container *ngSwitchCase="'LEADER_STRAIGHT_BID'">

                            <div class="bg-[#D4ECD5] rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#357B38]"> Congratulations!
                                </h3>
                                <p class="text-sm text-center text-sm mt-4 text-[#357B38]">
                                    Your <strong>Straight Bid of $ {{ selectedBid}} {{currency()}} </strong> has been
                                    recorded.</p>
                                <p class="text-sm text-center text-sm text-[#357B38]">You are currently the
                                    <strong>Leader</strong> for item <strong>{{ itemModal?.name }}</strong> with a
                                    <strong>Leading Bid of $ {{ selectedBid}} {{currency()}}.</strong> If you win, a
                                    fee will be added to your winning bid (${{ coverFeeConfirm ? feeSignalValue : 0}}
                                    {{currency()}} estimated). The final
                                    fee will
                                    be
                                    based on the winning bid amount.
                                </p>
                            </div>

                            <ng-template [ngTemplateOutlet]="templateBiddingButtons"></ng-template>

                        </ng-container>
                        <ng-container *ngSwitchCase="'LEADER_BELOW_RESERVE'">
                            <div
                                class="bg-[#FEF0CD] border border-[#B08620] rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#644D12]"> Your Bid is Below
                                    Reserve!
                                </h3>
                                <p class="text-sm text-center text-sm mt-4 text-[#B08620]">
                                    Your bid of $ {{ selectedBid}} {{currency()}} was successful but below the Reserve
                                    Price, which
                                    is the minimum
                                    amount the seller will accept. Since the reserve wasn't met, the item won't be sold.
                                    You need to place a higher bid to win.
                                <p class="text-sm  font-bold text-sm text-[#B08620] pt-4">You are currently the
                                    Please try again with a higher bid!
                                </p>
                            </div>
                            <ng-template [ngTemplateOutlet]="templateBiddingButtons"></ng-template>

                        </ng-container>

                        <ng-container *ngSwitchCase="'OUTBID'">
                            <div
                                class="bg-gray-200 border border-gray-300 rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#644D12]"> Outbid!
                                </h3>
                                <p class="text-sm text-center text-sm mt-4 text-[#B08620] font-semibold">
                                    Your bid was successful, but you've been outbid!
                                <p class="text-sm  text-sm text-[#B08620] pt-4">
                                    Your max bid of ${{selectedBid}} {{currency()}} matched another bidder's earlier max
                                    bid,
                                    so they’re still in the lead. <strong>Bid again to take the lead!.</strong>
                                </p>
                            </div>
                            <ng-template [ngTemplateOutlet]="templateBiddingButtons"></ng-template>

                        </ng-container>

                        <ng-container *ngSwitchCase="'TIE_LOSER'">
                            <div
                                class="bg-gray-200 border border-gray-300 rounded-md p-4 flex flex-col justify-center items-center mt-4">
                                <h3 class="text-lg font-mulish  font-semibold mb-1 text-[#644D12]"> Outbid!
                                </h3>
                                <p class="text-sm text-center text-sm mt-4 text-[#B08620] font-semibold">
                                    Your bid was successful, but you've been outbid!
                                <p class="text-sm  font-bold text-sm text-[#B08620] pt-4">We bid up to your <strong>
                                        Maximum Bid
                                        of ${{selectedBid}} {{currency()}} </strong> but another bidder had already
                                    placed a higher
                                    <strong>Maximum Bid.</strong>

                                    If you want to win this item, <strong>please bid again!</strong>
                                </p>
                            </div>
                            <ng-template [ngTemplateOutlet]="templateBiddingButtons"></ng-template>

                        </ng-container>

                    </ng-container>
                </ng-template>

                <!-- template Bidding Buttons -->

                <ng-template #templateBiddingButtons>
                    <div class="mt-6 flex gap-2 ">

                        <button pButton type="button"
                            class="  h-[35px] lg:h-[35px] !bg-white !border !border-[var(--p-primary-500)] !text-[var(--p-primary-500)] px-4 py-2 font-medium text-base flex-[1] !rounded-full flex justify-end items-center"
                            [routerLink]="['/item-list', auctionId]">
                            <i class="pi pi-angle-double-left text-xl"></i>
                            <span class="font-semibold  text-center w-full text-[13px] font-mulish">
                                Back to Items
                            </span>
                        </button>

                        <button pButton
                            class=" h-[35px] lg:h-[35px] !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full relative flex-[1] flex items-center justify-center gap-2 tracking-wide"
                            [rounded]="true" (click)="resetVariables()">
                            <i class="hidden lg:inline pi pi-credit-card !text-[var(--p-text-color-secondary)] text-xs left-3">
                            </i>
                            <span
                                class=" font-mulish font-semibold !text-[var(--p-text-color-primary)] text-center w-full text-[13px] tracking-wide">
                                Place New Bid
                            </span>
                        </button>
                    </div>
                </ng-template>

                <!-- switch item type buy, bid, buy-now -->

                <ng-container [ngSwitch]="itemType">
                    <ng-container *ngSwitchCase="'buy'">
                        <div>
                            <div class="flex flex-col lg:flex-row gap-2 w-full mt-4">

                                <div class="flex flex-col sm:flex-row gap-2 w-full gap-4">
                                    <div class="flex-1">
                                        <label
                                            class="block text-gray-500 text-sm font-semibold tracking-wide  ">Quantity</label>
                                        <p-inputNumber [(ngModel)]="quantity" [min]="1"
                                            [max]="itemModal?.quantityAvailable" mode="decimal" showButtons
                                            class="w-full  text-gray-500 text-sm h-[35px] mb-2 "></p-inputNumber>
                                        <span class="text-sm !text-[var(--p-info-500)] font-semibold">Only {{
                                            itemModal?.quantityAvailable }}
                                            available</span>
                                    </div>

                                    <div class="flex-1 sm:w-[90px]">
                                        <label
                                            class="block text-gray-500 text-sm font-semibold tracking-wide">Total</label>
                                        <input
                                            [value]="itemModal?.currentLeadingBid ? itemModal?.currentLeadingBid : itemModal?.buyNowPrice"
                                            class="w-full bg-gray-100 text-gray-500 border border-gray-300 rounded-lg p-2 text-xs h-[35px] "
                                            readonly>
                                    </div>
                                </div>


                            </div>

                            @if (showAddToCartButton()) {
                                <app-add-to-cart-button [auctionId]="auctionId!" [lineItems]="lineItems()" [checkIfAdded]="true"></app-add-to-cart-button>
                            } @else {
                                <button pButton
                                        class="p-button mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                        [rounded]="true"
                                        (click)="isAuthenticated().isAuthenticated ? embeddedPaymentLoad() : openLoginModal() ">
                                    <i class="pi !text-[var(--p-text-color-primary)] absolute left-3"
                                        [ngClass]="itemModal?.isBiddable || itemModal?.isBuyable ? 'pi-credit-card' : 'pi-bookmark'">
                                    </i>
                                    <span class="font-mulish !text-[var(--p-text-color-primary)] text-center w-full">
                                        Buy Now
                                    </span>
                                </button>
                            }

                            <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>


                            <div class="flex flex-col md:flex-row justify-between md:items-center mt-4 ">
                                <div class="flex items-center text-gray-600 space-x-1 text-[12px]">
                                    <i class="pi pi-users !text-[var(--p-info-500)] font-bold text-xs"></i>

                                    <span>
                                        {{itemModal?.numberSold === 0 ? 'Be first in line to buy!' :
                                        itemModal?.numberSold + ' people already purchased this item' }}
                                    </span>

                                </div>
                                <div class="flex items-center text-gray-600 space-x-1 text-[12px] mt-1">
                                    <i class="pi pi-calendar !text-[var(--p-info-500)] font-bold "></i>
                                    <span>{{ itemDateFormat()}}</span>
                                </div>
                            </div>
                            <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                            </p>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'bid'">

                        <ng-container *ngIf="!showConfirmTemplate && !showBidStatus">
                            <ng-template [ngTemplateOutlet]="bidControls"></ng-template>
                        </ng-container>

                        <ng-container *ngIf="showConfirmTemplate && !showBidStatus">
                            <ng-template [ngTemplateOutlet]="bidConfirmTemplate"></ng-template>
                        </ng-container>

                        <ng-container *ngIf="showBidStatus">
                            <ng-template *ngTemplateOutlet="bidStatusTemplate"></ng-template>
                        </ng-container>

                    </ng-container>

                    <ng-container *ngSwitchCase="'buy-bid'">
                        <ng-container *ngIf="!showConfirmTemplate && !showBidStatus">
                            <ng-template [ngTemplateOutlet]="bidControls"></ng-template>
                        </ng-container>

                        <ng-container *ngIf="showConfirmTemplate && !showBidStatus">
                            <ng-template [ngTemplateOutlet]="bidConfirmTemplate"></ng-template>
                        </ng-container>

                        <ng-container *ngIf="showBidStatus">
                            <ng-template *ngTemplateOutlet="bidStatusTemplate"></ng-template>
                        </ng-container>

                        <button *ngIf="!showConfirmTemplate && !showBidStatus" pButton
                            class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                            [rounded]="true" (click)="embeddedPaymentLoad()">
                            <i class="pi !text-[var(--p-text-color-secondary)] absolute left-3"
                                [ngClass]="itemModal?.isBiddable || itemModal?.isBuyable ? 'pi-credit-card' : 'pi-bookmark'">
                            </i>
                            <span class="font-mulish !text-[var(--p-text-color-secondary)] text-center w-full">
                                Buy Now {{ itemModal?.buyNowPrice }} {{currency()}}
                            </span>
                        </button>
                        <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>


                    </ng-container>

                    <ng-container [ngSwitch]="itemType">
                        <ng-container *ngSwitchCase="'sold'">
                            <div class=" mt-4">
                                <div
                                    class="bg-orange-200 rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                    <h3 class="text-base font-mulish  font-semibold mb-1">SOLD!</h3>
                                </div>

                                <button pButton
                                    class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                    [rounded]="true" (click)="toggleFavorite()">
                                    <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
                                    </i>
                                    <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                                        {{ itemFavoriteSignal() ? 'Remove from my Favorites' : 'Add to my Favorites' }}
                                    </span>
                                </button>
                                <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                    <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                </p>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container [ngSwitch]="itemType">
                        <ng-container *ngSwitchCase="'event'">
                            <div class=" mt-4">
                                <div
                                    class="bg-[#DFE7EF] rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                    <h3 class="text-base font-mulish  font-semibold mb-1">Live Event Item</h3>
                                    <p class="text-sm font-mulish  text-center">
                                        <span> You can place your bid on the item exclusively at the live event
                                            on</span> {{ openingDateFormat()}}
                                    </p>
                                </div>

                                <button pButton
                                    class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                    [rounded]="true" (click)="toggleFavorite()">
                                    <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
                                    </i>
                                    <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                                        {{ itemFavoriteSignal() ? 'Remove from my Favorites' : 'Add to my Favorites' }}
                                    </span>
                                </button>
                                <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block">
                                    <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                </p>

                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container [ngSwitch]="itemType">
                        <ng-container *ngSwitchCase="'online'">
                            <div class=" mt-4">
                                <div
                                    class="bg-lime-200 rounded-md p-4 flex flex-col justify-center items-center  min-h-32">
                                    <h3 class="text-base font-mulish  font-semibold mb-1">Online Open</h3>
                                    <p class="text-sm font-mulish  text-center">
                                        <span>This item will be available on</span> {{ openingDateFormat()}}
                                    </p>
                                </div>

                                <button pButton
                                    class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                    [rounded]="true" (click)="toggleFavorite()">
                                    <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
                                    </i>
                                    <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                                        {{ itemFavoriteSignal() ? 'Remove from my Favorites' : 'Add to my Favorites' }}
                                    </span>
                                </button>
                                <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                    <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                </p>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container [ngSwitch]="itemType">
                        <ng-container *ngSwitchCase="'upcoming'">
                            <div class=" mt-4">
                                <div
                                    class="bg-lime-100 rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                    <h3 class="text-base font-mulish  font-semibold mb-1">Online Open</h3>
                                    <p class="text-sm font-mulish  text-center">
                                        <span>This item will be available on</span> {{ openingDateFormat()}}
                                    </p>
                                </div>

                                <button pButton
                                    class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center "
                                    [rounded]="true" (click)="toggleFavorite()">
                                    <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
                                    </i>
                                    <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                                        {{ itemFavoriteSignal() ? 'Remove from my Favorites' : 'Add to my Favorites' }}
                                    </span>
                                </button>
                                <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                    <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                </p>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container [ngSwitch]="itemType">
                        <ng-container *ngSwitchCase="'closed'">
                            <div class=" mt-4">
                                <div
                                    class="bg-orange-200 rounded-md p-4 flex flex-col justify-center items-center min-h-32">
                                    <h3 class="text-base font-mulish  font-semibold mb-1">Item Closed</h3>

                                    <p class="text-sm font-mulish  text-center">
                                        <span>This item closed on</span> {{ itemDateFormat()}}
                                    </p>
                                </div>

                                <button pButton
                                    class="!bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 rounded-m w-full lg:h-[35px] relative flex items-center justify-center"
                                    [rounded]="true" (click)="toggleFavorite()">
                                    <i class="pi pi-bookmark !text-[var(--p-text-color-secondary)] absolute left-3">
                                    </i>
                                    <span class="font-mulish text-base !text-[var(--p-text-color-secondary)] text-center w-full">
                                        {{ itemFavoriteSignal() ? 'Remove from my Favorites' : 'Add to my Favorites' }}
                                    </span>
                                </button>
                                <p *ngIf="showWinningBidText()" class="text-gray-600 space-x-2 text-[12px] mt-2 block ">
                                    <ng-container class="" *ngTemplateOutlet="FGFwording"></ng-container>
                                </p>
                            </div>
                        </ng-container>
                    </ng-container>

                </ng-container>
            </div>
        </div>

        <!-- <div class="flex flex-col md:flex-row gap-8 w-full h-full "> -->
        <div class="flex flex-col md:flex-row  max-w-[1200px]  mt-20 lg:mt-24 ">
            <p-tabs [(value)]="activeTab" class=" w-full" [scrollable]="true" (valueChange)="onTabChange($event)">
                <p-tablist>
                    <p-tab *ngFor="let tab of filteredTab" [value]="tab.value" class="text-sm md:text-base ">{{
                        tab.title
                        }}</p-tab>
                </p-tablist>

                <p-tabpanels>
                    <p-tabpanel *ngFor="let tab of filteredTab " [value]="tab.value">
                        <ng-container *ngIf="tab.value === 0">
                            <div class="flex flex-col md:flex-row   ">
                                <div class="flex-1 pr-8">
                                    <h3 class="font-bold text-sm">Description</h3>
                                    <h1 class="text-sm lg:mt-4" [innerHTML]="safeDescriptionHtml()"></h1>
                                </div>
                                @if (safeSpecialNoteHtml().toString().length > 0) {
                                <div class="flex-1 lg:ml-8  mt-4 lg:mt-0">
                                    <h3 class="font-bold text-sm ">Item Special Note</h3>
                                    <h1 class="text-sm lg:mt-4" [innerHTML]="safeSpecialNoteHtml()"></h1>
                                </div>
                                }
                            </div>

                            <div *ngIf="itemModal?.donors!.length > 0" class="mt-12">
                                <h3 class="font-bold text-sm">Generously donated by</h3>
                                <p class="text-xs">With immense gratitude, we acknowledge the generous contributions
                                    that make this
                                    event possible.</p>
                                <div class="w-full">

                                    <app-donors [donors]="itemModal?.donors!"></app-donors>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="tab.value === 1">
                            <div class="overflow-x-auto">
                                <h2 class="text-base font-semibold">Ask a question about this item</h2>
                                <div class="flex flex-col w-full">
                                    <span class="text-gray-600 font-semibold text-[14px] mt-4">Your Question</span>
                                    <textarea pInputTextarea rows="5" class="w-full mt-2"
                                        [(ngModel)]="askAQuestionControl" (input)="onQuestionChange()"></textarea>
                                </div>
                                <small class="text-red-500 block min-h-[1rem]" *ngIf="responseError">
                                    {{ responseError }}
                                </small>

                                <div class="flex justify-end mt-4">
                                    <button pButton class="!text-[var(--p-text-color-secondary)]
                                    !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] mt-6 w-[160px] h-[40px]"
                                        (click)="onAskAQuestion()" [rounded]="true">
                                        Send
                                    </button>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="tab.value === 2">
                            <div class="w-full flex flex-col flex-1 min-h-0">
                                 <div class="flex flex-col md:flex-row justify-between  w-full mt-6">
                                    <h2 class="text-[18px] md:text-[20px font-medium">Frequently Asked Questions</h2>
                                    <a href="https://support.frontstream.com/hc/en-us/sections/115001633423-Bidder-FAQ"
                                        class="flex items-center gap-1 text-fs-blue font-semibold text-base">
                                        <i class="pi pi-link "></i>
                                        View Full FAQ
                                    </a>

                                </div>
                                <div class="mt-4 md:mt-10 w-full flex-1">
                                    <p-accordion class="w-full max-w-full">
                                        @for (faq of faqs; track faq.question) {
                                        <p-accordion-panel [value]="faq.value">
                                            <p-accordion-header class="text-sm">{{ faq.question }}</p-accordion-header>
                                            <p-accordion-content>
                                                <p class="m-0">{{ faq.answer }}</p>
                                            </p-accordion-content>
                                        </p-accordion-panel>
                                        }
                                    </p-accordion>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="tab.value === 3 ">
                            <div>
                                <h2 class="text-[16px] font-semibold">Item Bid History</h2>
                                <div>
                                    <p>
                                        <span class="text-[14px] font-semibold">{{itemModal?.name}}</span>
                                        <span class="ml-2 text-xs">(Item Number {{itemModal?.lotNumber}})</span>
                                    </p>
                                </div>
                            </div>
                            <div class="flex flex-col-reverse md:flex-col">

                                <div class="mt-6 lg:mt-2 text-right">
                                    <a href="https://support.frontstream.com/hc/en-us/articles/115005888343-Understanding-Bid-Histories-Bid-Increments"
                                        class="text-blue-500 text-sm">More Info on bid increments & bid
                                        histories</a>
                                </div>

                                <div class=" hidden md:block overflow-x-auto">
                                    <table class="w-full table-fixed border border-gray-200 mt-6">
                                        <thead class="bg-[var(--p-primary-500)] rounded-r-lg !text-[var(--p-text-color-primary)] text-sm">
                                            <tr>
                                                <th class="text-left px-4 py-2">Placed On</th>
                                                <th class="text-left px-4 py-2">Placed By</th>
                                                <th class="text-left px-4 py-2">$</th>
                                                <th class="text-left px-4 py-2 hidden md:block">Details</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-200 text-sm ">
                                            <tr *ngFor="let bid of formatBidHistory">
                                                <td class="px-4 py-2">{{ bid.placedOn }}</td>
                                                <td class="px-4 py-2"
                                                    [ngClass]=" {'font-bold': bid.placedBy === userName && isAuthenticated().isAuthenticated} ">
                                                    {{
                                                    bid.placedBy }}</td>

                                                <td class="px-4 py-2">{{ bid.amount }}</td>
                                                <td class="p-3 hidden md:block">
                                                    <ng-container *ngFor="let caption of bid.captions">
                                                        <button
                                                            (click)="activeCaption = caption; openCaptionModal(caption, bid)"
                                                            class="text-blue-500 hover:underline block w-full mb-1 text-left">
                                                            {{ caption | captionBid }}
                                                        </button>
                                                    </ng-container>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- vertical  -->

                                <div class="md:hidden overflow-x-auto mt-2">
                                    <div *ngFor="let bid of formatBidHistory"
                                        class="border-b rounded-md shadow-sm bg-white text-sm space-y-1 mt-4">
                                        <p>
                                            <span class="font-bold text-gray-600">Placed On:</span>
                                            <span class="text-gray-500"> {{ bid.placedOn }}</span>
                                        </p>
                                        <p>
                                            <span class="font-bold text-gray-600">Placed By:</span>
                                            <span class="text-gray-500"> {{ bid.placedBy }}</span>
                                        </p>
                                        <p>
                                            <span class="font-bold text-gray-600">Amount:</span>
                                            <span class="text-gray-500"> {{ bid.amount }}</span>
                                        </p>
                                        <ng-container *ngFor="let caption of bid.captions">
                                            <button (click)="activeCaption = caption; openCaptionModal(caption, bid)"
                                                class="text-blue-500 hover:underline block text-left">
                                                {{ caption | captionBid }}
                                            </button>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>

            <!-- </div> -->
        </div>
    </div>
</ng-template>

@if(loadingEPF()){
<div class="fixed inset-0 z-50 flex items-center justify-center min-h-[300px]">
    <p-progress-spinner ariaLabel="loading" />
</div>
}


<ng-template #FGFwording>
  <p class="text-xs text-gray-700 font-mulish mt-6">
  The winning bid will go to
  <a
    href="https://frontstreamglobalfund.org/"
    class="text-blue-500 underline"
  >
    FrontStream Global Fund
  </a>
  (tax ID 26-3265577), a 501c3 nonprofit organization, which will send the donation to
  {{ homePageSignal()?.orgName }} (tax ID {{ homePageSignal()?.taxId }}) on behalf of the winner.
</p>
</ng-template>

<ng-template #OnlineToLiveEvent>
<div class="bg-[rgba(25,166,223,0.2)] border border-[var(--fs-blue)] rounded-xl p-6 text-center mt-6">

    <h3 class="text-[20px] font-bold text-center font-mulish">Starts Online, Ends at Live Event</h3>

    <p class="text-gray-500 text-sm  font-medium font-mulish">
       Bidding for this item starts online and continues during the Live Event.
        The highest online bid carries forward as the opening bid at the Live Event.
    </p>

    @if(isAbsenteeBiddingEnabled()){
        <p>
           
           <span  class="cursor-pointer ml-2 mr-2 text-[var(--dark-blue)] inline-flex items-center gap-2 font-bold" title="More info"   (click)="onAbsenteeBidModal()"  >
                Absentee Bidding
                <i class="pi pi-question-circle"></i>
                </span>
            <span class=" text-gray-500 text-sm">available</span>                                         
        </p>
    }
</div>
</ng-template>


<div class="mt-[20px] lg:mt-[80px]">
    <app-footer></app-footer>
</div>


<app-bidding-question-mark (close)="onModalClose()" [visible]="displayQuestionModal">
</app-bidding-question-mark>

<!-- bid history modals explanations  -->
<app-straight-bid [visible]="displayStraigthBidModal" (close)="onModalExplanationClose()"></app-straight-bid>
<app-tie-bid [visible]="displayTieWinBidModal" (close)="onModalExplanationClose()"
    [tieExplanation]="tieDetails"></app-tie-bid>
<app-reserve-met [visible]="displayReserveMetBidModal" (close)="onModalExplanationClose()"></app-reserve-met>
<app-below-reserve-bid [visible]="displayBelowReserveBidModal"
    (close)="onModalExplanationClose()"></app-below-reserve-bid>
<app-absentee-bidding [visible]="displayAbsenteeBiddingModal" (close)="displayAbsenteeBiddingModal = false"></app-absentee-bidding>